import { render, staticRenderFns } from "./merge-wallet.vue?vue&type=template&id=31952a7c&"
import script from "./merge-wallet.vue?vue&type=script&lang=js&"
export * from "./merge-wallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports